//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import centers from "./centers"
import buttons from "./buttons"
export default {
    props: {
        typedd: {
             default: '2',
            type: String,
        },
        iserror: {
            default: false,
            type: Boolean
        },
        buttontext:{
            type:String,
            default:"OK"
        },
        buttontext_:{
            type:String,
            default:"OK"
        },
        tiptext:{
            type:String
        },
        emitbtn:{
           // type:Function
        },
        emitbtn_:{
            //type:Function
        }
    },
    computed:{
        showbtn(){
            return typeof this.emitbtn == 'function'
        },
        showbtn_(){
            return typeof this.emitbtn_ == 'function'
        }
    },
    methods: {
        hide_(){
            this.$emit("hide");
        },
    },
    components: {
        buttons,
        centers,
    }
}



// WEBPACK FOOTER //
// ./src/components/glocompoen/tips.vue